// dialogに関する共通処理を定義
// 	v-dialogにはv-model="showDialog"を仕様する
//
const dialogMixin = (condition = "withoutBtn") => {
	if (condition == "withoutBtn") {
		// 親要素からdialog.sync="dialog"を受け取る
		return {
			props: {
				dialog: {
					type: Boolean,
					default: false,
				},
			},
			methods: {
				closeDialog(closeFunction = null, args = []) {
					if (closeFunction !== null) closeFunction(...args)
					this.showDialog = false
				},
				scrollToTop() {
					const elements = document.getElementsByClassName("v-dialog--active")
					if (!elements || !elements.length) {
						return
					}
					elements[0].scrollTop = 0
				},
			},
			computed: {
				showDialog: {
					get() {
						return this.dialog
					},
					set(newVal) {
						return this.$emit("update:dialog", newVal)
					},
				},
			},
		}
	} else if (condition == "withBtn") {
		// 親要素ではdialogの表・示非表示を制御しない
		return {
			data() {
				return {
					showDialog: false,
				}
			},
			methods: {
				closeDialog(closeFunction = null, args = []) {
					if (closeFunction !== null) closeFunction(...args)
					this.showDialog = false
				},
				scrollToTop() {
					const elements = document.getElementsByClassName("v-dialog--active")
					if (!elements || !elements.length) {
						return
					}
					elements[0].scrollTop = 0
				},
			},
		}
	} else if (condition == "flexible") {
		// ボタンの表示・非表示を引数で制御する場合
		return {
			props: {
				dialog: {
					type: Boolean,
					default: false,
				},
				requireBtn: {
					type: Boolean,
					default: false,
				},
			},
			data() {
				return {
					dialogByBtn: false,
				}
			},
			methods: {
				closeDialog(closeFunction = null, args = []) {
					if (closeFunction !== null) closeFunction(...args)
					this.showDialog = false
				},
				scrollToTop() {
					const elements = document.getElementsByClassName("v-dialog--active")
					if (!elements || !elements.length) {
						return
					}
					elements[0].scrollTop = 0
				},
			},
			computed: {
				showDialog: {
					get() {
						if (this.requireBtn) {
							return this.dialogByBtn
						} else {
							return this.dialog
						}
					},
					set(newVal) {
						if (this.requireBtn) {
							this.dialogByBtn = newVal
						} else {
							return this.$emit("update:dialog", newVal)
						}
					},
				},
			},
		}
	}
}

export default dialogMixin
